/* eslint-disable no-empty-pattern */
import {call, put} from 'redux-saga/effects'
import {push} from 'connected-react-router'
import FiltersInterestActions from '../Redux/FiltersInterestRedux'
import AuthActions from '../Redux/AuthRedux'
import ErrorsActions from '../Redux/ErrorsRedux'

export function* getFiltersInterestLanguage(api, authApi, {}) {
  try {
    const response = yield call(api.getFiltersInterestLanguage)
    if (response && response.ok) {
      yield put(FiltersInterestActions.filtersInterestSuccess({languages: response.data}))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(FiltersInterestActions.filtersInterestFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getFiltersInterestLanguage(api, authApi, {})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(FiltersInterestActions.filtersInterestFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getFiltersInterestCategory(api, authApi, {language}) {
  try {
    const response = yield call(api.getFiltersInterestCategory, language)
    if (response && response.ok) {
      yield put(FiltersInterestActions.filtersInterestSuccess({categories: response.data}))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(FiltersInterestActions.filtersInterestFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getFiltersInterestCategory(api, authApi, {language})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(FiltersInterestActions.filtersInterestFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* getFiltersInterest(api, authApi, {language, search}) {
  try {
    const response = yield call(api.getFiltersInterest, language, search)
    if (response && response.ok) {
      yield put(FiltersInterestActions.filtersInterestSuccess({interests: response.data}))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave('Server response error'))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave('Server response error'))
      }
      yield put(FiltersInterestActions.filtersInterestFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getFiltersInterest(api, authApi, {language, search})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }
  } catch (e) {
    yield put(FiltersInterestActions.filtersInterestFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}
